/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "IssuedCard": {
            "nested": {
              "CardState": {
                "values": {
                  "ACTIVE": 1,
                  "DISABLED": 2,
                  "TERMINATED": 3,
                  "SUSPENDED": 4,
                  "VERIFIED": 5,
                  "ISSUED": 6,
                  "UNDELIVERABLE": 7,
                  "MONITORED": 12,
                  "SHIPPED": 8,
                  "CANCELLED": 9,
                  "REJECTED": 10,
                  "DESTROYED": 11
                }
              }
            }
          },
          "CardEvent": {
            "fields": {
              "issuedCardToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "storedValueToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "issuer": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.banklin.CardEvent.Type",
                "id": 4,
                "rule": "optional"
              },
              "result": {
                "type": ".squareup.banklin.CardEvent.Result",
                "id": 5,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "occurredAt": {
                "type": "int64",
                "id": 7,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "fideliusToken": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "cardState": {
                "type": ".squareup.banklin.IssuedCard.CardState",
                "id": 10,
                "rule": "optional"
              },
              "cardType": {
                "type": ".squareup.banklin.CardType",
                "id": 11,
                "rule": "optional"
              },
              "customerToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              }
            },
            "nested": {
              "Result": {
                "values": {
                  "SUCCESS": 1,
                  "FAILED": 2,
                  "ISSUER_EXCEPTION": 3,
                  "SUSPECTED_FRAUD": 4
                }
              },
              "Type": {
                "values": {
                  "ACTIVATED": 1,
                  "DISABLED": 2,
                  "ENABLED": 3,
                  "SUSPENDED": 4,
                  "REINSTATED": 5,
                  "ISSUED": 6,
                  "TERMINATED": 7,
                  "VERIFIED": 8,
                  "SHIPPED": 9,
                  "CANCELLED": 10,
                  "REJECTED": 11,
                  "DESTROYED": 12,
                  "SET_PIN": 13,
                  "UNDELIVERABLE": 14,
                  "REISSUED_LOST_OR_STOLEN": 15,
                  "REISSUED_DAMAGED": 16,
                  "UPDATED_IDV": 17,
                  "UPDATED_ADDRESS": 18,
                  "UPDATED_EMAIL": 19,
                  "COURIER_FIRST_SCANNED": 20,
                  "COURIER_IN_HOME_FORECAST": 21,
                  "COURIER_UNDELIVERABLE": 22,
                  "UPDATED_USER": 23,
                  "DEACTIVATED_USER": 24,
                  "ENABLED_ENHANCED_MONITORING": 25,
                  "ACTIVATED_USER": 26,
                  "SET_PRIMARY": 27,
                  "UNSET_PRIMARY": 28,
                  "UPDATED_BUSINESS": 29,
                  "DISABLED_ENHANCED_MONITORING": 30,
                  "ORDERED": 31,
                  "ACTIVATION_ATTEMPT": 32,
                  "ACTIVATION_RISK_EVALUATED": 33
                }
              }
            }
          },
          "CardType": {
            "values": {
              "VIRTUAL": 1,
              "PHYSICAL": 2
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.IssuedCard?.nested?.CardState && !$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent && !$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Result && !$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Type && !$root.nested?.squareup?.nested?.banklin?.nested?.CardType) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE IssuedCard @ squareup/banklin/issued_card.proto at 12:1
 */
export const IssuedCard = {};
/**
 * SOURCE CardState @ squareup/banklin/issued_card.proto at 80:3
 */
IssuedCard.CardState = $root.lookupEnum('squareup.banklin.IssuedCard.CardState').values;
/**
 * SOURCE CardEvent @ squareup/banklin/issued_card.proto at 173:1
 */
export const CardEvent = $root.lookupType('squareup.banklin.CardEvent');
fixType(CardEvent);
Builder.createAndAttachToType(CardEvent);
/**
 * SOURCE Result @ squareup/banklin/issued_card.proto at 187:3
 */
CardEvent.Result = $root.lookupEnum('squareup.banklin.CardEvent.Result').values;
/**
 * SOURCE Type @ squareup/banklin/issued_card.proto at 194:3
 */
CardEvent.Type = $root.lookupEnum('squareup.banklin.CardEvent.Type').values;
/**
 * SOURCE CardType @ squareup/banklin/issued_card.proto at 231:1
 */
export const CardType = $root.lookupEnum('squareup.banklin.CardType').values;
